// extracted by mini-css-extract-plugin
export default {"booking":"BookingPage_booking__akM3s","heroSection":"BookingPage_heroSection__XpjQh"};